import { render, staticRenderFns } from "./Post_Modal_Report.vue?vue&type=template&id=fa37462c&"
import script from "./Post_Modal_Report.vue?vue&type=script&lang=js&"
export * from "./Post_Modal_Report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports